/** Дублікат логіки lib/materialWindingMeters.js для UI закупок / матеріалів. */

const WINDING_KEY_LC = "намотка";

export function parseMetersFromWindingValue(raw) {
    if (raw == null) {
        return null;
    }
    const s = String(raw)
        .trim()
        .replace(/\u00a0/g, " ")
        .replace(",", ".");
    if (!s) {
        return null;
    }
    const m = s.match(/(\d+(?:\.\d+)?|\d*\.\d+)/);
    if (!m) {
        return null;
    }
    const n = Number(m[1]);
    if (!Number.isFinite(n) || n <= 0) {
        return null;
    }
    return n;
}

export function getWindingMetersFromPropertyPairs(pairs) {
    if (!Array.isArray(pairs)) {
        return null;
    }
    for (const p of pairs) {
        const k = String(p?.key ?? "")
            .trim()
            .toLowerCase();
        if (k === WINDING_KEY_LC) {
            return parseMetersFromWindingValue(p?.value);
        }
    }
    return null;
}
